export default __webpack_public_path__ + "static/cover-big-completely-af1e1493798200a0460a5b952424a230.png";